import { jsx as _jsx } from "react/jsx-runtime";
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa6';
export const SortCaret = (order) => {
    switch (order) {
        case 'asc':
            return _jsx(FaSortUp, { className: 'table-icon' });
        case 'desc':
            return _jsx(FaSortDown, { className: 'table-icon' });
        default:
            return _jsx(FaSort, { className: 'table-icon' });
    }
};
